module.exports = __webpack_public_path__ + "static/media/Checkmark.ab2595c1.svg";